import React from 'react';
import './_list.visual.editor.scss'
import './_list.visual.editor.dark-mode.scss'
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Loader from '../../../../../../components/Loaders/Loader';
import Tooltip from '../../../../../../components/Tooltip';

const ListVisualEditor = ({
  items,
  isLoading,
  onActivateTheme,
}) => (
  <>
    <div className="list-editor">
      {isLoading ? <Loader /> : null }
      <Row>
        {items.map((item) => (
          <Col md={6} key={`theme-${item.id}`}>
            <div className="list-editor__card">
              <div className="list-editor__card-preview" style={{ backgroundImage: `url(${item.thumbnail})` }}>
                {item.active
                  ? (
                    <div className="list-editor__card-active">
                      <div className="list-editor__card-badge">Active</div>
                      {item?.has_not_published ? (
                        <div className="list-editor__card-published">
                          <Tooltip
                            placement="top"
                            tooltipClass="tooltip__top"
                            text={(
                              <p>
                                Changes not published
                              </p>
                            )}
                          >
                            <i className="fas fa-upload" />
                          </Tooltip>
                        </div>
                      ) : null }
                    </div>
                  ) : null}
                {item.active ? (
                  <div className="list-editor__card-activate">
                    <Button href="/admin/editor" bsStyle="primary" disabled={isLoading}>
                      <i className="fas fa-magic" />
                      {' '}
                      Open editor
                    </Button>
                  </div>
                ) : null }
              </div>
              <div className="list-editor__card-panel">
                <div>
                  <div className="list-editor__card-name">{item.name}</div>
                  <div className="list-editor__card-updated">{item.last_modified ? `Last modified ${item.last_modified}` : null}</div>
                </div>
                {item?.access?.activate && !item.active ? (
                  <div>
                    <Button onClick={() => onActivateTheme(item.id)} disabled={isLoading}>Activate</Button>
                  </div>
                ) : null }
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  </>
);

ListVisualEditor.propTypes = {
  items: PropTypes.array,
  isLoading: PropTypes.bool,
  onActivateTheme: PropTypes.func,
};

export default ListVisualEditor;
